import React, { FunctionComponent } from 'react';

type Props = {
  logoPc: string;
  logoSp: string;
};

export const Presentation: FunctionComponent<Props> = ({
  logoPc,
  logoSp,
}) => {
  return (
    <header className="l-header l-header-responsive u-clear">
      <div className="l-header-logo">
        <a className="l-header-logo-link pc-logo" href="/">
          <h1>
            <img
              src={logoPc}
              className="l-header-logo-img"
              alt="READY TO FASHION"
              width="236"
            />
          </h1>
        </a>
        <a className="l-header-logo-link sp-logo" href="/">
          <h1>
            <img
              src={logoSp}
              className="l-header-logo-img"
              alt="READY TO FASHION"
              width="244"
            />
          </h1>
        </a>
      </div>
      <div className="l-header-login l-header-login-top">
        <a className="l-header-button btn" href="https://jinji.readytofashion.jp/service">
          <span className="btn-inner">
            採用担当の方へ
          </span>
        </a>
      </div>
    </header>
  );
};
